import SetWinnerCardComponent from "./setWinnerCard.container";

export default SetWinnerCardComponent;
